import { retryTask } from '@dispatch/shared/services';
import { NaqRetryResponse } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export function useRetryTask(
  onSuccess?: (data: NaqRetryResponse) => void,
  onError?: (error: unknown) => void,
  onSettled?: () => void
) {
  const queryClient = useQueryClient();
  return useMutation(async (taskId: string) => retryTask(taskId), {
    onSuccess,
    onError,
    onSettled: (_data, _error, taskId) => {
      onSettled && onSettled();

      queryClient.invalidateQueries(['task', taskId]);
      queryClient.invalidateQueries(['taskEvents']);
      queryClient.invalidateQueries(['summaries']);
      queryClient.invalidateQueries(['infos']);
      queryClient.invalidateQueries(['schedule-data']);
      queryClient.invalidateQueries(['schedule-data-infinite']);
    },
  });
}
